import { useEffect, useState } from 'react';

import {
    Box,
    MenuItem,
    Checkbox,
    TextField,
    FormControl,
    InputLabel,
    Select,
    ListItemText,
    Grid,
    InputAdornment,
    FormHelperText,
    Typography,
    OutlinedInput,
    IconButton,
    Dialog,
    DialogTitle,
    DialogContent,
    TableBody,
    TableRow,
    Table,
    Paper,
    TableHead,
    TableCell,
    TableContainer,
    TableFooter
} from '@mui/material';

// import { discountTypes } from "../../configs/discountConfig"
// import { getInitialTaxValues } from "../../schema/documents/taxSchema";

import { useSystemUtils } from '../useSystemUtils';

import { useRates, rateTypes, targetTypes } from "../api/useRates"

import { CommonIcons, icons } from "../../components/common/CommonIcons"
import { useTranslations } from '../useTranslations';

// import { checkValueExists } from "../../utils/dataSchema"

import { adjustmentTypes as _adjustmentTypes, initialValues, initialRowValues } from "../../schema/documents/adjustmentSchema"

export const adjustmentTypes = _adjustmentTypes

// import { spliceString } from '../../utils/formatString'

// import { inputTypes, inputTypesDef } from "../../schema/customFields/customFieldSchema"

// import { useAppContextFeatures } from '../../context/AppContext'
// import { useSystemPrompt } from '../useSystemPrompt';

// import { useCustomFields } from '../api/useCustomFields';

export function useDocumentAdjustments({
    formik: _formik,
    documentType: _documentType,
    handlePreviewChange,
    disableDiscount = false,
    disableTax = false,
    forceApplyAllTax = false,
    disableTaxSelection = false
}) {

    const { formatCurrencyDisplay, currencyAbb } = useSystemUtils()

    const { t } = useTranslations({ ns: ["common", "@document"] })

    const {
        handleSubmit, handleChange, values, errors, touched, setFieldValue,
    } = _formik

    // console.log('_formik', _formik)

    // const [documentType, setDocumentType] = useState(_documentType)

    const [taxPreviewOpen, setTaxPreviewOpen] = useState(false)

    const [taxes, setTaxes] = useState([])

    const [discountAmount, setDiscountAmount] = useState(0.00)
    const [taxAmount, setTaxAmount] = useState(0.00)
    const [netAmount, setNetAmount] = useState(0.00)
    const [grossAmount, setGrossAmount] = useState(0.00)
    const [selectedAdjustments, setSelectedAdjustments] = useState([
        // initialRowValues
    ])
    const [taxCalculation, setTaxCalculation] = useState([])

    const { list: listTaxes, filterOperatorTypes } = useRates({ rateType: rateTypes.taxRate, targetType: targetTypes.taxRate });

    const fetchTaxes = async () => {

        try {

            const props = {
                limit: -1,
                skip: 0,
                filterValue: [
                    {
                        name: `status`,
                        operator: filterOperatorTypes.eq,
                        value: 1
                    }
                ],
                sortInfo: {
                    id: "id",
                    dir: 0,
                }
            }

            let response = await listTaxes(props);

            // console.log('res tax', response)

            if (response?.data?.tax_rates) {
                setTaxes(response?.data?.tax_rates)

                // auto select the all taxes
                if (forceApplyAllTax === true) {

                    let newAdjustments = []

                    response?.data?.tax_rates.forEach(i5 => {

                        newAdjustments.push({
                            adjustment_id: "",
                            type: adjustmentTypes.tax,
                            refer_id: i5?.id,
                        })

                    })

                    setSelectedAdjustments(newAdjustments)

                }

            }

        } catch (error) {
            // promptMessage(false, `${error.message}`)
            console.error(`Failed to get tax rates`, error)
        }

    }

    useEffect(() => {

        if (disableTax === false) {
            fetchTaxes()
        }

    }, [])

    useEffect(() => {

        if (values)
            recalculateAdjustments()

    }, [selectedAdjustments, grossAmount, discountAmount])

    const getAdjustmentSchemaStateValues = (props) => {
        return {
            ...initialRowValues,
            ...props
        }
    }

    const getAmount = () => {
        return {
            grossAmount,
            taxAmount,
            discountAmount,
            netAmount
        }
    }

    const recalculateAdjustments = () => {

        let _grossAmount = parseFloat(grossAmount);
        let _discountAmount = discountAmount;
        let newNetAmount = _grossAmount;

        let totalTaxAmount = 0

        let taxCalculationSteps = []
        let stateTaxes = []

        selectedAdjustments.forEach(i => {

            let _taxId = i?.refer_id
            let _adjustmentId = i?.adjustment_id

            let _tax = taxes.filter(i2 => i2?.id === _taxId && i2?.type.toLowerCase() === adjustmentTypes.tax.toLowerCase())

            // console.log('_tax >> ', _tax)

            let _percent = 0
            let _taxAmount = 0
            let taxAmount = 0

            if (_tax.length > 0) {
                _percent = parseFloat(_tax[0]?.tax_percentage)
                _taxAmount = parseFloat((_grossAmount - _discountAmount) * _percent / 100)
                _taxAmount = Math.round(_taxAmount * 100) / 100
                taxAmount = parseFloat(_taxAmount)

                stateTaxes.push(
                    getAdjustmentSchemaStateValues({
                        adjustment_id: _adjustmentId,
                        type: adjustmentTypes.tax,
                        description: `${_tax[0]?.rate_name} (${_grossAmount - _discountAmount} x ${_percent}%)`,
                        adjustment_amount: parseFloat(taxAmount).toFixed(2),
                        adjustment_percentage: parseFloat(_percent).toFixed(2),
                        refer_id: _taxId,
                    })
                )

            }

            totalTaxAmount += taxAmount

            // update calculation states
            taxCalculationSteps.push({
                taxId: _taxId,
                amount: taxAmount
            })

        })

        setTaxCalculation(taxCalculationSteps)

        // check have discount
        newNetAmount = _grossAmount + totalTaxAmount - _discountAmount

        // summary
        let _a = parseFloat(totalTaxAmount).toFixed(2)
        let _b = parseFloat(newNetAmount).toFixed(2)

        // console.log('discountAmount', discountAmount)
        // console.log('newNetAmount', newNetAmount)

        // console.log('values', values)

        setTaxAmount(_a)
        setNetAmount(_b)
        setFieldValue(`adjustments.taxAmount`, _a)
        setFieldValue(`adjustments.netAmount`, _b)
        setFieldValue(`adjustments.discountAmount`, _discountAmount)
        setFieldValue(`adjustments.grossAmount`, _grossAmount)

        setFieldValue(`adjustments.rows`, stateTaxes)

    }

    const calculateSummaryRows = (props) => {

        if (!values?.rows) return false

        const {
            // setFieldValue,
            // formikValues: values,
            handleValueRow,
            // handleValueTax
        } = props

        // const {
        //     amount
        // } = values?.discount ? values.discount : {}

        let newTotalAmount = 0

        // console.log('values?.rows', values?.rows)

        // calculate the total rows
        if (values?.rows) {
            values.rows.forEach((item, index) => {

                // check the item?.price is object or value
                // console.log('typeof', typeof (item?.qty))

                let price = item.price ? item.price : 0;;
                let qty = 0;

                if (typeof (item?.qty) === "object") { // for nesteed schema object qty

                    qty = item?.qty?.value ? item.qty.value : 0;

                } else { // for normal qty values

                    qty = item.qty ? item.qty : 0;
                }

                let subTotal = parseFloat(price) * parseFloat(qty)

                if (handleValueRow) handleValueRow({ index, subTotal })

                newTotalAmount += subTotal

            })
        }

        setGrossAmount(parseFloat(newTotalAmount).toFixed(2))

        // check the discount is enabled
        // if (values?.discount) {
        //     if (values?.discount && values.discount.id === discountTypes.fixed.id) { // only allow fixed now
        //         newTotalAmount -= parseFloat(amount);

        //         setDiscountAmount(amount)

        //     } else {
        //         throw new Error(`Unsupported Discount Type : ${values.discount?.id}`)
        //     }
        // }

        // if (values?.tax) { // need tax

        //     // console.log('tax', values?.tax?.id)

        //     const taxValues = getInitialTaxValues(values.tax.id, newTotalAmount)

        //     if (handleValueTax) handleValueTax({ taxValues })

        //     // Object.keys(taxValues).forEach((e) => {
        //     //     setFieldValue(`tax.${e}`, taxValues[e])
        //     // })

        //     newTotalAmount += parseFloat(taxValues.amount)

        // }

        // setNetAmount(newTotalAmount)

        return {
            totalAmount: newTotalAmount
        }
    }

    const getCountTaxAdjustments = (selectedAdjustments) => {

        let _a = selectedAdjustments.filter(i => i.type.toLowerCase() === adjustmentTypes.tax.toLowerCase())

        let count = 0

        _a.forEach(i => {
            let _checkExistTax = taxes.filter(i2 => i2.id === i.refer_id)

            if (_checkExistTax.length > 0) {
                count += 1
            }

        })

        return count

    }

    const appendAdjustments = (taxIds) => {

        let newAdjustments = []

        taxIds.forEach(i => {

            let _checkExist = selectedAdjustments.filter(i2 => i2.refer_id === i && i2.type.toLowerCase() === adjustmentTypes.tax.toLowerCase())

            // console.log('_checkExist_checkExist_checkExist', _checkExist)

            if (_checkExist.length <= 0) {

                newAdjustments.push({
                    adjustment_id: "",
                    type: adjustmentTypes.tax,
                    refer_id: i,
                })

            } else {
                newAdjustments.push(_checkExist[0])
            }
        })

        setSelectedAdjustments(newAdjustments)

    }

    const RenderDocumentSummary = (props) => {

        let taxTypesArray = taxes

        return (
            <Grid container rowSpacing={0} rowGap={0} columnSpacing={1}>

                <Grid item xs={12} sm={12} md={6}>
                    <></>
                    {/* <Typography sx={{ fontSize: 11 }}>
                        {JSON.stringify(selectedAdjustments)}
                    </Typography>

                    <Typography sx={{ fontSize: 11 }}>
                        {JSON.stringify(values?.adjustments)}
                    </Typography> */}
                </Grid>

                {
                    (disableDiscount === false) ?

                        <Grid item xs={12} sm={12} md={6}>
                            <TextField
                                inputProps={{
                                    style: {
                                        textAlign: "right"
                                    }
                                }}

                                InputProps={{
                                    startAdornment: (
                                        <InputAdornment position="start">
                                            <CommonIcons name={icons.equal} />
                                        </InputAdornment>
                                    ),
                                }}

                                margin="normal"
                                size="small"
                                fullWidth
                                // name={"discount.amount"}
                                label={t("discount")}
                                type="text"
                                variant="outlined"
                                // value={values.discount.amount}
                                // value={
                                //     discountAmount
                                // }
                                value={`${values?.adjustments?.discountAmount}`}
                                onFocus={event => {
                                    event.target.select();
                                }}
                                onChange={(event) => {
                                    // setFieldValue(`discount.amount`, event.target.value);

                                    let val = event.target.value
                                    // console.log('val', val)

                                    if (val === "") {
                                        val = 0.00
                                    }

                                    setDiscountAmount(val)
                                }}
                                error={Boolean(errors?.discount?.amount)}
                                helperText={errors?.discount?.amount}
                            />
                        </Grid>

                        :

                        <Grid item xs={12} sm={12} md={6}><></></Grid>
                }

                {
                    (disableTax === false) &&

                    <>
                        <Grid item xs={12} sm={12} md={6}>
                            <FormControl
                                margin="normal"
                                fullWidth
                                size="small"
                                error={Boolean(errors?.tax?.id)}
                            >
                                <InputLabel id="taxId">{t("tax")}</InputLabel>
                                <Select

                                    disabled={
                                        disableTaxSelection
                                    }

                                    labelId="taxId"
                                    label={t("tax")}
                                    name={"taxId"}
                                    multiple
                                    input={<OutlinedInput label="Name" />}
                                    onChange={(event) => {
                                        // setFieldValue(`tax.id`, event.target.value)
                                        let _taxIds = event.target.value

                                        // setSelectedAdjustments(_taxIds)
                                        appendAdjustments(_taxIds)

                                    }}
                                    value={
                                        selectedAdjustments.map(i => {
                                            return i.refer_id
                                        })
                                        // checkValueExists({
                                        //     dataSearch: taxTypesArray,
                                        //     valueToCompare: values.tax.id
                                        // })
                                    }
                                    sx={{
                                        textAlign: 'left'
                                    }}
                                    renderValue={(selected) => {

                                        return `${getCountTaxAdjustments(selectedAdjustments)} Selected`
                                    }}
                                    endAdornment={
                                        <InputAdornment position="start">
                                            {
                                                selectedAdjustments.length > 0 &&
                                                <IconButton
                                                    onClick={() => {
                                                        // setTaxPreviewOpen(true)
                                                        handlePreviewChange(true)
                                                    }}
                                                >
                                                    <CommonIcons name={icons.info} />
                                                </IconButton>
                                            }
                                        </InputAdornment>
                                    }
                                >
                                    {
                                        taxTypesArray.map((i, index) => {

                                            let taxId = i?.id

                                            // check the tax is selected
                                            let _check = selectedAdjustments.filter(i2 => i2.refer_id === taxId && i2.type.toLowerCase() === adjustmentTypes.tax.toLowerCase())

                                            let checked = _check.length > 0

                                            return (
                                                // <MenuItem key={index} value={i.id}>{i.rate_name}</MenuItem>
                                                <MenuItem key={taxId} value={taxId}>
                                                    <Checkbox
                                                        checked={checked}
                                                    // checked={selectedAdjustments.indexOf(taxId) > -1} 
                                                    />
                                                    <ListItemText
                                                        primary={
                                                            `${i?.rate_name} (${parseFloat(i?.tax_percentage).toFixed(2)}%)`
                                                        }
                                                    />
                                                </MenuItem>
                                            )
                                        })
                                    }
                                </Select>
                                <FormHelperText>
                                    {errors?.tax?.id}
                                </FormHelperText>
                            </FormControl>
                        </Grid>

                        <Grid item xs={12} sm={12} md={6}>
                            <TextField
                                inputProps={{
                                    style: {
                                        textAlign: "right"
                                    }
                                }}
                                InputProps={{
                                    startAdornment: (
                                        <InputAdornment position="start">
                                            <CommonIcons name={icons.equal} />
                                        </InputAdornment>
                                    ),
                                }}
                                margin="normal"
                                size="small"
                                disabled
                                fullWidth
                                // name={"tax.amount"}
                                label={t("taxAmount")}
                                type="text"
                                variant="outlined"
                                // value={values?.tax?.amount ? values.tax.amount : "0.00"}
                                value={`${values?.adjustments?.taxAmount}`}
                            />
                        </Grid>
                    </>
                }

                <Grid item xs={12} sm={12} md={6}>
                    <></>
                </Grid>

                <Grid item xs={12} sm={12} md={6}>

                    <TextField
                        inputProps={{
                            style: {
                                textAlign: "right"
                            }
                        }}
                        InputProps={{
                            startAdornment: (
                                <InputAdornment position="start">
                                    <CommonIcons name={icons.equal} />
                                </InputAdornment>
                            ),
                        }}
                        margin="normal"
                        size="small"
                        disabled
                        fullWidth
                        // name={"totalamount"}
                        label={t("totalAmount")}
                        type="text"
                        variant="outlined"
                        // value={values?.totalamount ? values.totalamount : "0.00"}
                        value={`${values?.adjustments?.netAmount}`}
                    />
                </Grid>

            </Grid>
        )
    }

    const updateTaxPreviewOpen = (status) => {
        setTaxPreviewOpen(status)
    }

    const updateAdjustments = (currentAdjustments) => {
        // console.log('currentAdjustments', currentAdjustments, taxes)

        let overrideAdjustments = []

        let _currentAdjustments = currentAdjustments // .filter((value, index, array) => array.indexOf(value) === index)

        // check the id is exist (tax)
        _currentAdjustments.forEach(i => {
            let _check = taxes.filter(i2 => i2.id === i?.refer_id && i2?.type.toLowerCase() === adjustmentTypes.tax.toLowerCase())
            if (_check.length > 0) {
                overrideAdjustments.push({
                    adjustment_id: i?.id,
                    type: adjustmentTypes.tax,
                    refer_id: i?.refer_id
                })
            }
        })

        if (taxes.length > 0)
            setSelectedAdjustments(overrideAdjustments)


        let _adjustmentDiscountAmount = initialValues.discountAmount

        // check the id is exist (discount)
        let _checkDiscount = _currentAdjustments.filter(i2 => i2?.type.toLowerCase() === adjustmentTypes.discount.toLowerCase())

        if (_checkDiscount.length > 0) {
            _adjustmentDiscountAmount = parseFloat(_checkDiscount[0]?.adjustment_amount).toFixed(2)
        }

        setDiscountAmount(_adjustmentDiscountAmount)

    }

    const RenderDocumentTaxPreview = (props) => {
        return (
            <Dialog
                // sx={{
                //     '& .MuiDialog-paper':
                //         configs?.dialogStyle ?
                //             configs.dialogStyle
                //             :
                //             {
                //                 // width: '80%', 
                //                 // minHeight: '90vh'
                //                 // height: '90vh'
                //             }
                // }}
                fullWidth={Boolean(true)}
                maxWidth="md"
                // TransitionProps={{ onEntering: handleEntering }}
                open={taxPreviewOpen}
                // {...other}
                onClose={() => {

                    handlePreviewChange(false)

                }}
            // scroll='body'
            // {...configs?.dialogProps ? configs.dialogProps : {}}
            >
                <DialogTitle
                >
                    <Typography>
                        {t("appliedTax")}
                    </Typography>

                    <IconButton
                        aria-label="close"
                        onClick={() => {
                            handlePreviewChange(false)
                        }}
                        sx={{
                            position: 'absolute',
                            right: 10,
                            top: 10,
                            color: (theme) => theme.palette.grey[500],
                        }}
                    >
                        <CommonIcons name={icons.close} />
                    </IconButton>

                </DialogTitle>
                <DialogContent
                    dividers
                    // minheight="100%"
                    sx={{
                        // backgroundColor: 'red',
                        pl: 0,
                        pr: 0,
                    }}
                >

                    <Box sx={{
                        px: 1
                    }}>

                        <TableContainer>
                            <Table size="small" aria-label="customized table">
                                <TableHead>
                                    <TableRow>
                                        <TableCell>{t("no")}</TableCell>
                                        <TableCell align="left">{t("tax")}</TableCell>
                                        <TableCell align="center">%</TableCell>
                                        <TableCell align="right">{t("amount")}</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {
                                        selectedAdjustments.map((i, index) => {

                                            let _i = taxes.filter(i2 => i2?.id === i?.refer_id)
                                            let _calc = taxCalculation.filter(i2 => i2?.taxId === i?.refer_id)

                                            let item = _i.length > 0 ? _i[0] : {}
                                            let calc = _calc.length > 0 ? _calc[0] : {}

                                            let percent = item?.tax_percentage ? parseFloat(item.tax_percentage).toFixed(2) : 0

                                            let amount = calc?.amount ? parseFloat(calc.amount).toFixed(2) : 0.00

                                            return (
                                                <TableRow key={index}>
                                                    <TableCell>{(index + 1)}</TableCell>
                                                    <TableCell align='left'>
                                                        <ListItemText
                                                            primary={item?.rate_name}
                                                            secondary={item?.description}
                                                        />
                                                    </TableCell>
                                                    <TableCell align='center'>{percent} %</TableCell>
                                                    <TableCell align='right'>{formatCurrencyDisplay(amount)}</TableCell>
                                                </TableRow>
                                            )
                                        })
                                    }
                                </TableBody>
                                <TableFooter>
                                    <TableRow>
                                        <TableCell align='right' colSpan={3}>
                                            <Typography>
                                                {`${t("tax")} (${currencyAbb})`}
                                            </Typography>
                                        </TableCell>
                                        <TableCell align='right'>
                                            <Typography
                                                sx={{
                                                    fontSize: 13,
                                                    fontWeight: 700
                                                }}
                                            >
                                                {formatCurrencyDisplay(values?.adjustments?.taxAmount)}
                                            </Typography>
                                        </TableCell>
                                    </TableRow>
                                </TableFooter>
                            </Table>
                        </TableContainer>
                    </Box>

                    {/* <Typography>
                        {JSON.stringify(selectedAdjustments)}
                    </Typography> */}

                </DialogContent>
                {/* {
                    configs?.RenderDialogFooter &&
                    <DialogActions>
                        {
                            configs?.RenderDialogFooter({ data: configs?.data })
                        }
                    </DialogActions>

                } */}
                {/* <DialogActions>
                    <Button 
                        autoFocus 
                        // onClick={handleCancel}
                        onClick={() => {
                            handleOnCancel()
                        }}
                    >Cancel</Button>
                    <Button 
                        // onClick={handleOk}
                        onClick={() => {
                            handleOnConfirm()
                        }}
                    >Ok</Button>
                </DialogActions> */}
            </Dialog>
        )
    }

    const getPayloadSubmitCreate = (props) => {
        let taxRows = values?.adjustments?.rows ? values.adjustments.rows : []
        let taxDiscount = [
            getAdjustmentSchemaStateValues({
                type: adjustmentTypes.discount,
                description: `Fixed discount`,
                adjustment_amount: parseFloat(discountAmount).toFixed(2),
                adjustment_percentage: 0.00,
                refer_id: 0,
            })
        ]

        return [...taxRows, ...taxDiscount]

    }

    return {
        getAmount,
        calculateSummaryRows,
        RenderDocumentSummary,
        RenderDocumentTaxPreview,
        updateTaxPreviewOpen,
        getPayloadSubmitCreate,
        updateAdjustments,
    }

}